module.exports = __webpack_public_path__ + "static/Dashboard-e7d30989b1fb1a6822cf6d5ef1c5ce7b.png";